import React from 'react'
import { string } from 'prop-types'
import { DescriptionIcon } from '@wf-sl/common-icons'
import { FixedHint } from '../fixed-hint/fixed-hint'

const propTypes = {
    className: string,
    text: string.isRequired
}

function RemoveHint({ className, text }) {
    return <FixedHint iconComponent={DescriptionIcon} {...{ className, text }} />
}

RemoveHint.propTypes = propTypes

export { RemoveHint }
